const getFileDataUrl = (file, callback) => {
  const fr = new FileReader();

  fr.onload = callback;
  fr.readAsDataURL(file);
};

export default { getFileDataUrl };
